/* istanbul ignore file */
import CacheService from "@/services/cacheService.js";

export default {
  install(app) {
    app.config.globalProperties.$cache = CacheService;
  },
};
